//---------------------//
// tabla de provedores //
//---------------------//
import React, { useState, useEffect, useCallback } from 'react';
import { MaterialReactTable } from 'material-react-table';
import { MRT_Localization_ES } from 'material-react-table/locales/es/index.esm.js';
import { Button, TextField, Box, Modal, Typography, Tooltip, Divider } from '@mui/material';
import axios from 'axios';
import { CSVLink } from 'react-csv';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import { jwtDecode } from 'jwt-decode';
import { RiAddBoxLine, RiFolderDownloadLine, RiShareBoxFill, RiFileEditLine,
         RiDeleteBin6Line, RiSave3Fill, RiReplyAllLine, RiReplyAllFill } from "react-icons/ri";

const Proveedores = ({ setTitle, isSidebarOpen }) => {

  // variable leida desde archivo .env o .env.production //
  const apiUrl = process.env.REACT_APP_API_URL;

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [proveedores, setProveedores] = useState([]);
  const [open, setOpen] = useState(false);
  const [editingProveedor, setEditingProveedor] = useState(null);
  const [search, setSearch] = useState('');
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState(''); // Para mostrar el mensaje de error cliente ya existe //

  const [id, setId] = useState(0);
  const [rutPrv, setRutPrv] = useState('');
  const [nombrePrv, setnombrePrv] = useState('');
  const [direccionPrv, setdireccionPrv] = useState('');
  const [comunaPrv, setcomunaPrv] = useState('');
  const [ciudadPrv, setciudadPrv] = useState('');
  const [telefonoPrv, settelefonoPrv] = useState('');
  const [emailPrv, setemailPrv] = useState('');
  const [clavesiiPrv, setclavesiiPrv] = useState('');
  const [claveunicaPrv, setclaveunicaPrv] = useState('');
  
  // tamaño de la pantalla //
  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  // Cambio de titulo //
  useEffect(() => {
    setTitle(' Proveedores');
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [setTitle]);
  
  // Obtiene el ancho disponible para la tabla considerando el sidebar
  const availableWidth = isSidebarOpen ? windowWidth - 220 : windowWidth;

  // Función para verificar la validez del token
  const isTokenValid = (token) => {
    try {
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000; // Obtener el tiempo actual en segundos
      return decoded.exp >= currentTime; // Retorna si el token no ha expirado
    } catch (error) {
      return false; // Si el token no es válido, retornar false
    }
  };

  // Función para manejar la expiración del token y redirigir al login
  const handleTokenExpiration = useCallback(() => {
    handleCloseModal();
    Swal.fire({
      icon: 'error',
      title: 'Sesión expirada',
      text: 'El token ha expirado. Por favor, inicia sesión nuevamente.',
      footer: '▶️ Overwatch',
      background: 'rgba(30, 41, 59, 0.9)', // equilibrio entre opaco y transparente
      color: '#f8fafc',
      customClass: {
        popup: 'swal-custom-popup',
        title: 'swal-custom-title',
        htmlContainer: 'swal-custom-text'
      },
      showConfirmButton: false,
      timer: 1500
    });
    sessionStorage.removeItem('authToken'); // Limpiar el token de sessionStorage
    // window.location.href = '/login'; // Redirigir al login
    setTimeout(() => {
      window.location.href = '/login'; // Redirigir al login //
    }, 1600); // Un retraso ligeramente mayor que el timer de SweetAlert2 //
  }, []); // Aquí pasamos un array vacío porque `handleTokenExpiration` no depende de nada en particular

  // Función para cancelar y limpiar los arreglos //
  const handleCancel = () => {
    setProveedores([]);
    setSearch('');
    fetchProveedores();
   };

  // Validación de formato de email //
  const validarEmail = (email) => {
    // Expresión regular para validar el formato del email
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  // cargar todos los registros de la tabla proveedores //
  const fetchProveedores = useCallback(async () => {
    try {
      // Obtener el token desde sessionStorage //
      const token = sessionStorage.getItem('authToken');

      if (!token || !isTokenValid(token)) {
        handleTokenExpiration(); // Manejar la expiración del token y redirigir
        return; // Evitar continuar con el código si el token es inválido o expirado
      }
  
      const response = await axios.post( `${apiUrl}/proveedores/getproveedores`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,  // Incluir el token en el encabezado Authorization
          },
        }
      );

      if (response.data.success && response.data.rows) {
        setProveedores(response.data.rows); // Asigna los datos al estado //

      } else {
        setProveedores([]); // Si no hay datos, asegúrate de limpiar el estado //
      }
      
    } catch (error) {
      Swal.fire({
        position: "center",
        icon: "info",
        title: "No hay datos para mostrar...",
        footer: '▶️ Overwatch',
        background: 'rgba(30, 41, 59, 0.9)', // equilibrio entre opaco y transparente
        color: '#f8fafc',
        customClass: {
          popup: 'swal-custom-popup',
          title: 'swal-custom-title',
          htmlContainer: 'swal-custom-text'
        },
        showConfirmButton: false,
        timer: 1500
      });
    }
  }, [setProveedores, apiUrl, handleTokenExpiration]);

  // llamar a cargar proveedores //
  useEffect(() => {
    fetchProveedores();
  }, [fetchProveedores]);

  const handleInputChange = async (e, fieldName) => {
    const { value } = e.target;

    // Actualizamos el estado del campo correspondiente //
    switch (fieldName) {
      case 'rutPrv':
        setRutPrv(value);

        setErrors(prevErrors => ({
          ...prevErrors,
          rutPrv: '' // Limpiar el error del RUT al escribir //
        }));
  
        // Validación del RUT
        if (!validarRut(value)) {
          setMessage('');
          setErrors(prevErrors => ({
            ...prevErrors,
            rutPrv: 'El Rut no es válido'
          }));
          return; // Si el RUT no es válido, no continuar con la verificación de existencia //
        }
  
        // Verificar si el RUT ya existe en la base de datos success = false //
        try {
          // Rellenar con ceros a la izquierda hasta que rutPrv tenga un largo de 10 //
          const fixrutPrv = value.padStart(10, '0');

          // Verificar si el RUT ya existe en la base de datos
          const rutExists = await checkRutExists(fixrutPrv);

          // Revisar si el campo success en la respuesta es true //
          if (rutExists) {
            setMessage('El Rut ya existe en la Bd.'); // Mostrar mensaje si el RUT ya existe //
          } else {
            // Limpiar el mensaje si el RUT no existe //
            setMessage('');
          }
  
        } catch (error) {
          setMessage('Hubo un problema al verificar el RUT'); // Mensaje de error en caso de fallo en la verificación //
        }
        break;
  
        case 'nombrePrv':
          setnombrePrv(value);
          setErrors(prevErrors => ({
            ...prevErrors,
            nombrePrv: '' // Limpiar el error del Nombre //
          }));
          break;
    
        case 'direccionPrv':
          setdireccionPrv(value);
          setErrors(prevErrors => ({
            ...prevErrors,
            direccionPrv: '' // Limpiar el error de la Dirección //
          }));
          break;
    
        case 'comunaPrv':
          setcomunaPrv(value);
          setErrors(prevErrors => ({
            ...prevErrors,
            comunaPrv: '' // Limpiar el error de la Comuna //
          }));
          break;
    
        case 'ciudadPrv':
          setciudadPrv(value);
          setErrors(prevErrors => ({
            ...prevErrors,
            ciudadPrv: '' // Limpiar el error de la Ciudad //
          }));
          break;
    
        case 'telefonoPrv':
          settelefonoPrv(value);
          setErrors(prevErrors => ({
            ...prevErrors,
            telefonoPrv: '' // Limpiar el error del Teléfono //
          }));
          break;
    
        case 'emailPrv':
          setemailPrv(value);
        
          setErrors(prevErrors => ({
            ...prevErrors,
            emailPrv: ''
          }));
        
          // Validación del email
          if (!validarEmail(value)) {
            setMessage('');
            setErrors(prevErrors => ({
              ...prevErrors,
              emailPrv: 'El email no es válido'
            }));
            return; // Si el email no es válido, no continuar con la verificación //
          }
          break;

        case 'clavesiiPrv':
          setclavesiiPrv(value);
          setErrors(prevErrors => ({
            ...prevErrors,
            clavesiiPrv: '' // Limpiar el error de Clave SII //
          }));
          break;
    
        case 'claveunicaPrv':
          setclaveunicaPrv(value);
          setErrors(prevErrors => ({
            ...prevErrors,
            claveunicaPrv: '' // Limpiar el error de Clave Unica //
          }));
          break;
    
      default:
        break;
    }
  
    // Limpiamos el error para este campo //
    setErrors(prevErrors => ({
      ...prevErrors,
      [fieldName]: '' // Borra el error para el campo correspondiente //
    }));
  };

  // Validación del Rut (Módulo 11) //
  const validarRut = (rut) => {
    let valor = rut.replace(/\./g, '').replace('-', '');
    let cuerpo = valor.slice(0, -1);
    let dv = valor.slice(-1).toUpperCase();
    let suma = 0;
    let multiplo = 2;

    for (let i = 1; i <= cuerpo.length; i++) {
      let index = multiplo * valor.charAt(cuerpo.length - i);
      suma += index;
      multiplo = multiplo < 7 ? multiplo + 1 : 2;
    }

    let dvEsperado = 11 - (suma % 11);
    dvEsperado = dvEsperado === 11 ? '0' : dvEsperado === 10 ? 'K' : dvEsperado.toString();
    return dv === dvEsperado;
  };

  // Verificar si el RUT ya existe en la base de datos
  const checkRutExists = async (rut) => {
    try {
      const token = sessionStorage.getItem('authToken');

      if (!token || !isTokenValid(token)) {
        handleTokenExpiration(); // Manejar la expiración del token y redirigir
        return; // Evitar continuar con el código si el token es inválido o expirado
      }
  
      // Rellenar con ceros a la izquierda hasta que un largo de 10 //
      const rutPrv = rut.padStart(10, '0');

      const data = await axios.post(`${apiUrl}/proveedores/checkrut`,
        { rutPrv },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
          }
        }
      );

      return data.data.success;

    } catch (error) {
      return false; // Si hubo un error, retornar false //
    }
  };

  // Agregar o Editar Provedor //
  const handleSave = async () => {
    const validationErrors = {};
    setMessage(''); // Limpiar mensaje de error previo //

    if (!rutPrv) validationErrors.rutPrv = 'El Rut es obligatorio';
    if (!nombrePrv) validationErrors.nombrePrv = 'El Nombre es obligatorio';
    if (!direccionPrv) validationErrors.direccionPrv = 'La Dirección es obligatoria';
    if (!comunaPrv) validationErrors.comunaPrv = 'La Comuna es obligatoria';
    if (!ciudadPrv) validationErrors.ciudadPrv = 'La Ciudad es obligatoria';
    if (!telefonoPrv) validationErrors.telefonoPrv = 'El Teléfono es obligatorio';
    if (!emailPrv) validationErrors.emailPrv = 'El Email es obligatorio';

    // Validación de formato de email
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (emailPrv && !emailRegex.test(emailPrv)) {
      validationErrors.emailPrv = 'El Email no es válido';
    }
    
    if (!validarRut(rutPrv)) {
      validationErrors.rutPrv = 'El Rut no es válido';
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // Rellenar con ceros a la izquierda hasta que tenga un largo de 10 //
    const fixrutPrv = rutPrv.padStart(10, '0');
    // Convertir a mayúsculas //
    const uppernombrePrv = nombrePrv.toUpperCase();
    const upperdireccionPrv = direccionPrv.toUpperCase();
    const uppercomunaPrv = comunaPrv.toUpperCase();
    const upperciudadPrv = ciudadPrv.toUpperCase();
    // Convertir a minúsculas //
    const loweremailPrv = emailPrv.toLowerCase();

    // update del registro //
    try {
      if (editingProveedor) {
        // Obtener el token desde sessionStorage //
        const token = sessionStorage.getItem('authToken');

        if (!token || !isTokenValid(token)) {
          handleTokenExpiration(); // Manejar la expiración del token y redirigir
          return; // Evitar continuar con el código si el token es inválido o expirado
        }

        await axios.post(`${apiUrl}/proveedores/updateproveedor`, {
          id_prv: id,
          rut_prv: fixrutPrv,
          nombre_prv: uppernombrePrv,
          direccion_prv: upperdireccionPrv,
          comuna_prv: uppercomunaPrv,
          ciudad_prv: upperciudadPrv,
          telefono_prv: telefonoPrv,
          email_prv: loweremailPrv,
          clavesii_prv: clavesiiPrv,
          claveunica_prv: claveunicaPrv,
        }, {
          headers: {
            'Authorization': `Bearer ${token}`} // Pasar el token en los encabezados //
        });
    // insert registro //
      } else {
        // Verificar si el RUT ya existe en la base de datos
        const rutExists = await checkRutExists(fixrutPrv);

        // Revisar si el campo success en la respuesta es true
        if (rutExists) {
          // Si el servidor responde que la validacion no fue exitosa
          setMessage('Proveedor Ya Existe.');
          setErrors({});
          return;
        }

        // Obtener el token desde sessionStorage //
        const token = sessionStorage.getItem('authToken');

        if (!token || !isTokenValid(token)) {
          handleTokenExpiration(); // Manejar la expiración del token y redirigir
          return; // Evitar continuar con el código si el token es inválido o expirado
        }
     
        await axios.post(`${apiUrl}/proveedores/addproveedor`, {
          rut_prv: fixrutPrv,
          nombre_prv: uppernombrePrv,
          direccion_prv: upperdireccionPrv,
          comuna_prv: uppercomunaPrv,
          ciudad_prv: upperciudadPrv,
          telefono_prv: telefonoPrv,
          email_prv: loweremailPrv,
          clavesii_prv: clavesiiPrv,
          claveunica_prv: claveunicaPrv,
        }, {
          headers: {
            'Authorization': `Bearer ${token}` // Pasar el token en los encabezados //
          }
        });
      }
      fetchProveedores();
      handleCloseModal();

    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        footer: '▶️ Overwatch',
        text: error.message || 'Hubo un problema al procesar la solicitud.',
        allowOutsideClick: false,  // 👈 evita cierre con click afuera
        background: 'rgba(30, 41, 59, 0.9)', // equilibrio entre opaco y transparente
        color: '#f8fafc',
        customClass: {
          popup: 'swal-custom-popup',
          title: 'swal-custom-title',
          htmlContainer: 'swal-custom-text'
        }
      });
      }
  };

  // eliminar registro //
  const handleDelete = async (id, rut, nombre) => {
    const result = await Swal.fire({
      title: "¿Está seguro de eliminar?",
      footer: '▶️ Overwatch',
      allowOutsideClick: false,  // 👈 evita cierre con click afuera
      background: 'rgba(30, 41, 59, 0.9)', // equilibrio entre opaco y transparente
      color: '#f8fafc',
      customClass: {
        popup: 'swal-custom-popup',
        title: 'swal-custom-title',
        htmlContainer: 'swal-custom-text'
      },
      html: `
        <b>Rut: ${rut}</b><br>
        <b>Nombre: ${nombre}</b>
      `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, eliminar!",
      cancelButtonText: "Cancelar"
    });
  
    if (result.isConfirmed) {
      try {
        // Obtener el token desde sessionStorage //
        const token = sessionStorage.getItem('authToken');

        if (!token || !isTokenValid(token)) {
          handleTokenExpiration(); // Manejar la expiración del token y redirigir
          return; // Evitar continuar con el código si el token es inválido o expirado
        }
    
        await axios.post(
          `${apiUrl}/proveedores/deleteproveedor`,
          { id_prv: id },
          {
          headers: {
            'Authorization': `Bearer ${token}` // Pasar el token en los encabezados //
          }
        });
  
        Swal.fire({
          title: "¡Eliminado!",
          text: "El registro ha sido eliminado correctamente.",
          footer: '▶️ Overwatch',
          icon: "success",
          allowOutsideClick: false,  // 👈 evita cierre con click afuera
          background: 'rgba(30, 41, 59, 0.9)', // equilibrio entre opaco y transparente
          color: '#f8fafc',
          customClass: {
            popup: 'swal-custom-popup',
            title: 'swal-custom-title',
            htmlContainer: 'swal-custom-text'
          }
        });
  
        fetchProveedores();
        
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          footer: '▶️ Overwatch',
          text: "Error al eliminar el registro...!!!",
          allowOutsideClick: false,  // 👈 evita cierre con click afuera
          background: 'rgba(30, 41, 59, 0.9)', // equilibrio entre opaco y transparente
          color: '#f8fafc',
          customClass: {
            popup: 'swal-custom-popup',
            title: 'swal-custom-title',
            htmlContainer: 'swal-custom-text'
          }
        });
      }
    }
  };
  
  // Abrir Modal para Editar proveedor //
  const handleEdit = (proveedor) => {
    setId(proveedor.id_prv);
    setRutPrv(proveedor.rut_prv);
    setnombrePrv(proveedor.nombre_prv);
    setdireccionPrv(proveedor.direccion_prv);
    setcomunaPrv(proveedor.comuna_prv);
    setciudadPrv(proveedor.ciudad_prv);
    settelefonoPrv(proveedor.telefono_prv);
    setemailPrv(proveedor.email_prv);
    setclavesiiPrv(proveedor.clavesii_prv);
    setclaveunicaPrv(proveedor.claveunica_prv);
    setEditingProveedor(proveedor);
    setMessage('');
    setOpen(true);

     // Limpiar el error de todos los input //
     setErrors(prevErrors => ({
      ...prevErrors,
      id: 0,
      rutPrv: '',
      nombrePrv: '',
      direccionPrv: '',
      comunaPrv: '',
      ciudadPrv: '',
      telefonoPrv: '',
      emailPrv: ''
    }));
  };

  // Abrir Modal para Crear Proveedor //
  const handleAdd = () => {
    setRutPrv('');
    setnombrePrv('');
    setdireccionPrv('');
    setcomunaPrv('');
    setciudadPrv('');
    settelefonoPrv('');
    setemailPrv('');
    setclavesiiPrv('');
    setclaveunicaPrv('');
    setEditingProveedor(null);
    setMessage('');
    setOpen(true);

    // Limpiar el error de todos los input //
    setErrors(prevErrors => ({
      ...prevErrors,
      rutPrv: '',
      nombrePrv: '',
      direccionPrv: '',
      comunaPrv: '',
      ciudadPrv: '',
      telefonoPrv: '',
      emailPrv: ''
    }));
  };

  // estado para modal //
  const handleCloseModal = () => setOpen(false);

  // busqueda de proveedores //
  const filteredProveedores = (proveedores || []).filter((proveedor) =>
    proveedor.nombre_prv.toLowerCase().includes(search.toLowerCase()) ||
  proveedor.rut_prv.includes(search)
  );

  // exportar a pdf todos los datos de la tabla //
  const logo = new Image();
  logo.src = '/Overwatch.jpg'; // Ruta del logo //
  
  const exportToPDF = () => {
      const doc = new jsPDF('landscape');

      // Añadir logo //
      const logoX = 5; // Posición X del logo //
      const logoY = 5; // Posición Y del logo //
      doc.addImage(logo, "JPEG", logoX, logoY, 60, 10);
  
      // Fecha y página alineados a la derecha //
      doc.setFontSize(10);
      const fecha = `Fecha: ${new Date().toLocaleDateString()}`;
      const pagina = `Página 1 de 1`;
      const pageWidth = doc.internal.pageSize.width;
  
      // Calcular posición de la fecha y la página //
      const fechaX = pageWidth - doc.getTextWidth(fecha) - 5; // 10 de margen //
      const paginaX = pageWidth - doc.getTextWidth(pagina) - 5; // 10 de margen //
  
      // Colocar fecha y página en la misma línea que el logo //
      const textY = logoY + 10; // Alinear verticalmente con el logo //
      const paginaY = textY + 5; // Colocar la paginación 5 unidades más abajo //
  
      doc.text(fecha, fechaX, textY);
      doc.text(pagina, paginaX, paginaY); // Usar nueva posición Y para la paginación //
  
      // Título //
      doc.setFontSize(18);
      doc.text('Listado de Proveedores', 120, 25); // horizontal, vertical //
  
      // Tabla de proveedores //
      doc.autoTable({
          head: [['RUT', 'NOMBRE','DIRECCIÓN','COMUNA','CIUDAD','TELÉFONO','EMAIL']],
          body: proveedores.map((proveedor) => [
            proveedor.rut_prv,
            proveedor.nombre_prv,
            proveedor.direccion_prv,
            proveedor.comuna_prv,
            proveedor.ciudad_prv,
            proveedor.telefono_prv,
            proveedor.email_prv ]),
          foot: [['Total', proveedores.length]],
          startY: 30, // Comenzar la tabla después de los encabezados //
          styles: {
              fontSize: 12,
              cellPadding: 3,
              halign: 'center',
          },
          headStyles: {
              fillColor: [22, 160, 133], // Color de encabezado //
              textColor: [255, 255, 255], // Color de texto en encabezado //
          },
          footStyles: {
              fillColor: [22, 160, 133], // Color de pie de página //
              textColor: [255, 255, 255], // Color de texto en pie de página //
          },
      });
  
      // Total de registros //
      doc.text(`Registros: ${proveedores.length}`, 10, doc.internal.pageSize.height - 10);
      doc.save('proveedores.pdf');
  };
  
  logo.onerror = () => {
      console.error('Error al cargar la imagen del logo.', logo.src);
  };

  
  // Mostrar columnas en MaterialReactTable //
  const columns = [
    {
      id: 'actions',
      header: 'Acciones',
      size: 100,
      muiTableHeadCellProps: {
        sx: {
          backgroundColor: '#85c1e9', // Color de fondo azul para el encabezado
          color: 'black', // Color blanco para el texto del encabezado
        },
      },
      Cell: ({ row }) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Tooltip title="Editar" placement="top" arrow>
            <Button
              onClick={() => handleEdit(row.original)} // obtiene el dato original antes de ser modificado //
              color="primary"
              variant="contained"
              size="small"  // Hace los botones más pequeños //
              style={{
                minWidth: 0,
                padding: 0, // Elimina el padding para ajustarse mejor al tamaño del ícono
                display: 'flex', // Usa flexbox para centrar el contenido
                justifyContent: 'center', // Centrar el ícono horizontalmente
                alignItems: 'center', // Asegurarse de que el ícono esté centrado verticalmente
                width: 30, // Ajusta el tamaño del botón al ícono (puedes cambiar este valor según sea necesario)
                height: 30, // Ajusta el tamaño del botón al ícono (puedes cambiar este valor según sea necesario)
              }}
            >
              <RiFileEditLine size={24} />
            </Button>
          </Tooltip>
      
          <Tooltip title="Eliminar" placement="top" arrow>
            <Button
              onClick={() => handleDelete(row.original.id_prv, row.original.rut_prv, row.original.nombre_prv)}
              color="secondary"
              variant="contained"
              size="small"  // Hace los botones más pequeños //
              style={{
                minWidth: 0,
                padding: 0, // Elimina el padding para ajustarse mejor al tamaño del ícono
                display: 'flex', // Usa flexbox para centrar el contenido
                justifyContent: 'center', // Centrar el ícono horizontalmente
                alignItems: 'center', // Asegurarse de que el ícono esté centrado verticalmente
                width: 30, // Ajusta el tamaño del botón al ícono (puedes cambiar este valor según sea necesario)
                height: 30, // Ajusta el tamaño del botón al ícono (puedes cambiar este valor según sea necesario)
              }}
            >
              <RiDeleteBin6Line size={24} />
            </Button>
          </Tooltip>
        </div>
      ),
    },
    {
      header: 'Id',
      accessorKey: 'id_prv',
      size: 80,
      muiTableHeadCellProps: {
        sx: { textAlign: 'center',
              fontSize: '0.8rem',
              backgroundColor: '#85c1e9', // Color azul
              color: 'black', // Color del texto en el encabezado (blanco para contrastar)
            }
      },
      muiTableBodyCellProps: {
        sx: {
          textAlign: 'center',
          fontSize: '0.7rem',  // Asegúrate de que aquí se aplica el tamaño de fuente
        },
      },
    },
    {
      header: 'Rut',
      accessorKey: 'rut_prv',
      size: 98,
      muiTableHeadCellProps: {
        sx: { textAlign: 'center',
              fontSize: '0.8rem',
              backgroundColor: '#85c1e9', // Color azul
              color: 'black', // Color del texto en el encabezado (blanco para contrastar)
            }
      },
      muiTableBodyCellProps: {
        sx: {
          textAlign: 'center',
          fontSize: '0.7rem',
        },
      },
    },
    {
      header: 'Nombre',
      accessorKey: 'nombre_prv',
      size: 250,
      muiTableHeadCellProps: {
        sx: { textAlign: 'center',
              fontSize: '0.8rem',
              backgroundColor: '#85c1e9', // Color azul
              color: 'black', // Color del texto en el encabezado (blanco para contrastar)
            }
      },
      muiTableBodyCellProps: {
        sx: {
          textAlign: 'center',
          fontSize: '0.7rem',
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          overflowWrap: 'break-word',
        },
      },
    },
    {
      header: 'Dirección',
      accessorKey: 'direccion_prv',
      size: 250,
      muiTableHeadCellProps: {
        sx: { textAlign: 'center',
              fontSize: '0.8rem',
              backgroundColor: '#85c1e9', // Color azul
              color: 'black', // Color del texto en el encabezado (blanco para contrastar)
            }
      },
      muiTableBodyCellProps: {
        sx: {
          textAlign: 'center',
          fontSize: '0.7rem',
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          overflowWrap: 'break-word',
        },
      },
    },
    {
      header: 'Comuna',
      accessorKey: 'comuna_prv',
      size: 150,
      muiTableHeadCellProps: {
        sx: { textAlign: 'center',
              fontSize: '0.8rem',
              backgroundColor: '#85c1e9', // Color azul
              color: 'black', // Color del texto en el encabezado (blanco para contrastar)
            }
      },
      muiTableBodyCellProps: {
        sx: {
          textAlign: 'center',
          fontSize: '0.7rem',
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          overflowWrap: 'break-word',
        },
      },
    },
    {
      header: 'Ciudad',
      accessorKey: 'ciudad_prv',
      size: 150,
      muiTableHeadCellProps: {
        sx: { textAlign: 'center',
              fontSize: '0.8rem',
              backgroundColor: '#85c1e9', // Color azul
              color: 'black', // Color del texto en el encabezado (blanco para contrastar)
            }
      },
      muiTableBodyCellProps: {
        sx: {
          textAlign: 'center',
          fontSize: '0.7rem',
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          overflowWrap: 'break-word',
        },
      },
    },
    {
      header: 'Teléfono',
      accessorKey: 'telefono_prv',
      size: 200,
      muiTableHeadCellProps: {
        sx: { textAlign: 'center',
              fontSize: '0.8rem',
              backgroundColor: '#85c1e9', // Color azul
              color: 'black', // Color del texto en el encabezado (blanco para contrastar)
            }
      },
      muiTableBodyCellProps: {
        sx: {
          textAlign: 'center',
          fontSize: '0.7rem',
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          overflowWrap: 'break-word',
        },
      },
    },
    {
      header: 'Email',
      accessorKey: 'email_prv',
      size: 225,
      muiTableHeadCellProps: {
        sx: { textAlign: 'center',
              fontSize: '0.8rem',
              backgroundColor: '#85c1e9', // Color azul
              color: 'black', // Color del texto en el encabezado (blanco para contrastar)
            }
      },
      muiTableBodyCellProps: {
        sx: {
          textAlign: 'center',
          fontSize: '0.7rem',
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          overflowWrap: 'break-word',
        },
      },
    },
  ];

  // render de los datos //
  return (
    <div>
      <Box sx={{ display: 'flex',
                 gap: 1,
                 alignItems: 'center',
                 mt: 1,
                 mb: 1,
                 height: '70px',
                 flexWrap: 'wrap', // Permite que los elementos se acomoden en múltiples líneas si es necesario
                 maxWidth: '100%',
              }}>

        <TextField
          label="Buscar..."
          variant="outlined"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          fullWidth
          sx={{ 
            width: 290,
            height: '40px', // Altura del TextField Tipo
            '& .MuiOutlinedInput-root': { height: '40px' },
            '& .MuiSelect-select': { textAlign: 'center' },
            '& .MuiFormLabel-root': { textAlign: 'left', width: '100%' } // Centrando el label
          }}
        />

        <Tooltip title="Agregar Nuevo Registro" placement="top" arrow>
          <Button variant="contained"
            onClick={handleAdd}
            sx={{
              width: '160px',
              height: '40px',
              textTransform: 'none',
              backgroundColor: '#8b888e', // Color de fondo inicial
              color: 'white', // Color del texto en blanco
              '&:hover': {
                backgroundColor: '#65a76c', // Cambia el color de fondo a verde al pasar el mouse //
                color: 'white', // Cambia el color del texto a blanco //
              }
            }}
          >
            <RiAddBoxLine className="m-2" style={{ fontSize: '1.5rem' }} />
            Agregar
          </Button>
        </Tooltip>

        {/* Botón Cancelar */}
        <Tooltip title="Cancelar Todo" placement="top" arrow>
          <Button
            variant="contained"
            onClick={handleCancel}
            sx={{
              width: '180px',
              height: '40px',
              textTransform: 'none',
              backgroundColor: '#8b888e', // Color de fondo para cancelar
              color: 'white',
              '&:hover': {
                backgroundColor: '#b9770e', // Color al pasar el cursor //
                color: 'white',
              },
              '& .MuiButton-startIcon': {
                color: 'white',
              },
            }}
          >
            {/* Icono de cancelar */}
            <RiReplyAllFill className="m-2" style={{ fontSize: '1.5rem' }} />
            Cancelar
          </Button>
        </Tooltip>

        <Tooltip title="Exportar a Pdf" placement="top" arrow>
          <Button variant="contained"
            onClick={exportToPDF}
            sx={{
              width: '100px',
              height: '40px',
              backgroundColor: '#8b888e', // Color de fondo inicial
              color: 'white', // Color del texto en blanco
              '&:hover': {
                backgroundColor: '#65a76c', // Cambia el color de fondo a verde al pasar el mouse //
                color: 'white', // Cambia el color del texto a blanco //
              }
            }}
          >
           <RiFolderDownloadLine className="m-2" style={{ fontSize: '1.5rem' }} /> {/* Aumento el tamaño del icono */}
            PDF
          </Button>
        </Tooltip>

        <Tooltip title="Exportar a Csv" placement="top" arrow>
          <Button variant="contained"
            sx={{
              width: '100px',
              height: '40px',
              backgroundColor: '#8b888e', // Color de fondo inicial
              color: 'white', // Color del texto en blanco
              '&:hover': {
                backgroundColor: '#65a76c', // Cambia el color de fondo a verde al pasar el mouse //
                color: 'white', // Cambia el color del texto a blanco //
              }
            }}
          >
            <RiShareBoxFill className="m-2" style={{ fontSize: '1.5rem' }} /> {/* Aumento el tamaño del icono */}
            <CSVLink data={proveedores} filename="proveedores.csv">
              CSV
            </CSVLink>
          </Button>
        </Tooltip>

        {/* Configuración MaterialReactTable */}
        <div style={{
            display: 'block', // Habilita el modelo de bloque para el contenedor //
            boxSizing: 'border-box', // Incluye los bordes y el padding en el cálculo de dimensiones //
            padding: '1px', // Añade un poco de espacio para evitar que la tabla toque navBar //
            maxWidth: '98%',
            width: availableWidth, // Tamaño disponible según si esta abierto el sidebar //
            overflowX: 'auto',
          }}>
          <MaterialReactTable
            columns={columns}
            data={filteredProveedores}
            enablePagination
            localization={MRT_Localization_ES}
            initialState={{
              density: 'compact',
              pagination: {
                pageSize: 10,
              },
            }}
            muiTableHeadRowProps={{
              sx: {
                height: '40px', // Altura del encabezado //
              },
            }}
            muiTableBodyRowProps={{
              sx: {
                height: '40px', // Altura de la fila //
                '& td': {
                  padding: '8px 16px', // Espaciado interno de las celdas //
                },
                backgroundColor: '#f2f3f4', // Color de fondo para las filas del cuerpo
              },
            }}
            muiTableContainerProps={{
              sx: {
                maxHeight: '600px', // Establecer una altura máxima para la tabla
                overflowY: 'auto', // Permitir desplazamiento vertical cuando el contenido sea más largo que el contenedor
                'table': {
                  tableLayout: 'fixed', // Aplica table-layout: fixed para controlar el ancho de las columnas
                  backgroundColor: '#eaeded', // Color de fondo para toda la tabla
                }
              },
            }}
        />
        </div>

        {/* Modal para ingresar o modificar */}
        <Modal
          open={open}
          onClose={(event, reason) => {
            // Solo cerrar si el motivo NO es 'backdropClick' ni 'escapeKeyDown'
            if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
              handleCloseModal();
            }
          }}
          >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 600,
              bgcolor: '#f2f3f4',
              // bgcolor: 'background.paper',
              boxShadow: 24,
              p: 3,
            }}
          >
            <Typography variant="h6" component="h2" sx={{ color: '#ca531f' }}>
              {editingProveedor ? 'Editar Proveedor' : 'Agregar Proveedor'}
            </Typography>
            <Divider sx={{ marginY: 2 }} />
            <div className="mb-4" /> {/* Esta línea añade un margen inferior */}

            {/* Mostrar mensaje de error si existe */}
            {message && (
              <Typography color="error" sx={{ marginBottom: 2 }}>
                {message}
              </Typography>
            )}

            {/* ID - Mostrar solo si estamos en modo de edición */}
            {editingProveedor && (
              <TextField
                label="ID"
                value={id}
                fullWidth
                sx={{
                  marginBottom: 2, // Reducir margen inferior
                  '& .MuiInputBase-root': { height: 40 }, // Ajustar la altura del campo
                }}
                error={Boolean(errors.id)}
                helperText={errors.id || ""}
                disabled={true} // Siempre deshabilitado
                autoComplete="off"
              />
            )}

            {/* RUT */}
            <TextField
              label="Rut"
              value={rutPrv}
              onChange={(e) => handleInputChange(e, 'rutPrv')}
              fullWidth
              sx={{
                marginBottom: 2,
                '& .MuiInputBase-root': { height: 40 }, // Ajustar la altura del campo
              }}
              error={Boolean(errors.rutPrv)}
              helperText={errors.rutPrv}
              disabled={Boolean(editingProveedor)} // Deshabilitar si estamos editando un cliente //
              autoComplete="off" // Desactivar autocompletado //
            />

            {/* NOMBRE */}
            <TextField
              label="Nombre"
              value={nombrePrv}
              onChange={(e) => handleInputChange(e, 'nombrePrv')}
              fullWidth
              sx={{
                marginBottom: 2,
                '& .MuiInputBase-root': { height: 40 }, // Ajustar la altura del campo
              }}
              error={Boolean(errors.nombrePrv)}
              helperText={errors.nombrePrv}
              autoComplete="off" // Desactivar autocompletado //
              autoFocus // Agregar enfoque al cargar el componente //
            />

            {/* DIRECCION */}
            <TextField
              label="Dirección"
              value={direccionPrv}
              onChange={(e) => handleInputChange(e, 'direccionPrv')}
              fullWidth
              sx={{
                marginBottom: 2,
                '& .MuiInputBase-root': { height: 40 }, // Ajustar la altura del campo
              }}
              error={Boolean(errors.direccionPrv)}
              helperText={errors.direccionPrv}
              autoComplete="off" // Desactivar autocompletado //
            />

            {/* COMUNA */}
            <TextField
              label="Comuna"
              value={comunaPrv}
              onChange={(e) => handleInputChange(e, 'comunaPrv')}
              fullWidth
              sx={{
                marginBottom: 2,
                '& .MuiInputBase-root': { height: 40 }, // Ajustar la altura del campo
              }}
              error={Boolean(errors.comunaPrv)}
              helperText={errors.comunaPrv}
              autoComplete="off" // Desactivar autocompletado //
            />

            {/* CIUDAD */}
            <TextField
              label="Ciudad"
              value={ciudadPrv}
              onChange={(e) => handleInputChange(e, 'ciudadPrv')}
              fullWidth
              sx={{
                marginBottom: 2,
                '& .MuiInputBase-root': { height: 40 }, // Ajustar la altura del campo
              }}
             error={Boolean(errors.ciudadPrv)}
              helperText={errors.ciudadPrv}
              autoComplete="off" // Desactivar autocompletado //
            />

            {/* TELEFONO */}
            <TextField
              label="Teléfono"
              value={telefonoPrv}
              onChange={(e) => handleInputChange(e, 'telefonoPrv')}
              fullWidth
              sx={{
                marginBottom: 2,
                '& .MuiInputBase-root': { height: 40 }, // Ajustar la altura del campo
              }}
              error={Boolean(errors.telefonoPrv)}
              helperText={errors.telefonoPrv}
              autoComplete="off" // Desactivar autocompletado //
            />

            {/* EMAIL */}
            <TextField
              label="Email"
              value={emailPrv}
              onChange={(e) => handleInputChange(e, 'emailPrv')}
              fullWidth
              sx={{
                marginBottom: 2,
                '& .MuiInputBase-root': { height: 40 }, // Ajustar la altura del campo
              }}
              error={Boolean(errors.emailPrv)}
              helperText={errors.emailPrv}
              autoComplete="off" // Desactivar autocompletado //
            />

            {/* CLAVE SII */}
            <TextField
              label="Clave Sii"
              value={clavesiiPrv}
              onChange={(e) => handleInputChange(e, 'clavesiiPrv')}
              fullWidth
              sx={{
                marginBottom: 2,
                '& .MuiInputBase-root': { height: 40 }, // Ajustar la altura del campo
              }}
              error={Boolean(errors.clavesiiPrv)}
              helperText={errors.clavesiiPrv}
              autoComplete="off" // Desactivar autocompletado //
            />

            {/* CLAVE UNICA */}
            <TextField
              label="Clave Única"
              value={claveunicaPrv}
              onChange={(e) => handleInputChange(e, 'claveunicaPrv')}
              fullWidth
              sx={{
                marginBottom: 2,
                '& .MuiInputBase-root': { height: 40 }, // Ajustar la altura del campo
              }}
              error={Boolean(errors.claveunicaPrv)}
              helperText={errors.claveunicaPrv}
              autoComplete="off" // Desactivar autocompletado //
            />

            {/* display: 'flex'. Esto coloca los botones uno al lado del otro. El gap: '8px' agrega un espacio de 8 píxeles entre los botones. */}
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' }}>
              <Button
                variant="contained"
                color="primary"
                sx={{
                  width: '180px',
                  // padding: '6px 16px', // Ajustar padding para que los botones tengan el mismo tamaño //
                  height: '40px',
                  backgroundColor: '#8b888e', // Color de fondo inicial
                  color: 'white', // Color del texto en blanco
                  '&:hover': {
                    backgroundColor: 'red', // Cambia el color de fondo a verde al pasar el mouse //
                    color: 'white', // Cambia el color del texto a blanco //
                  }
                }}
                onClick={handleSave}>
                <RiSave3Fill className="m-2" style={{ fontSize: '1.5rem' }} /> {/* Aumento el tamaño del icono */}
                {editingProveedor ? 'Regrabar' : 'Grabar'}
              </Button>
  
              <Button
                variant="outlined"
                sx={{
                  width: '180px',
                  // padding: '6px 16px', // Ajustar padding para que los botones tengan el mismo tamaño //
                  height: '40px', // Establece la altura constante //
                  backgroundColor: '#8b888e', // Color de fondo inicial
                  color: 'white', // Color del texto en blanco
                  '&:hover': {
                    backgroundColor: 'green', // Cambia el color de fondo a verde al pasar el mouse //
                    color: 'white', // Cambia el color del texto a blanco //
                  }
                }}
                onClick={handleCloseModal}>
                <RiReplyAllLine className="m-2" style={{ fontSize: '1.5rem' }} /> {/* Aumento el tamaño del icono */}
                Cancelar
              </Button>
            </div>
          </Box>
        </Modal>
      </Box>
    </div>
  );
};

export default Proveedores;
